/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

export {ÉµgetDOM} from '@angular/common';
export {BROWSER_SANITIZATION_PROVIDERS as ÉµBROWSER_SANITIZATION_PROVIDERS, BROWSER_SANITIZATION_PROVIDERS__POST_R3__ as ÉµBROWSER_SANITIZATION_PROVIDERS__POST_R3__, INTERNAL_BROWSER_PLATFORM_PROVIDERS as ÉµINTERNAL_BROWSER_PLATFORM_PROVIDERS, initDomAdapter as ÉµinitDomAdapter} from './browser';
export {BrowserDomAdapter as ÉµBrowserDomAdapter} from './browser/browser_adapter';
export {TRANSITION_ID as ÉµTRANSITION_ID} from './browser/server-transition';
export {BrowserGetTestability as ÉµBrowserGetTestability} from './browser/testability';
export {escapeHtml as ÉµescapeHtml} from './browser/transfer_state';
export {ELEMENT_PROBE_PROVIDERS as ÉµELEMENT_PROBE_PROVIDERS} from './dom/debug/ng_probe';
export {DomRendererFactory2 as ÉµDomRendererFactory2, NAMESPACE_URIS as ÉµNAMESPACE_URIS, flattenStyles as ÉµflattenStyles, shimContentAttribute as ÉµshimContentAttribute, shimHostAttribute as ÉµshimHostAttribute} from './dom/dom_renderer';
export {DomEventsPlugin as ÉµDomEventsPlugin} from './dom/events/dom_events';
export {HammerGesturesPlugin as ÉµHammerGesturesPlugin} from './dom/events/hammer_gestures';
export {KeyEventsPlugin as ÉµKeyEventsPlugin} from './dom/events/key_events';
export {DomSharedStylesHost as ÉµDomSharedStylesHost, SharedStylesHost as ÉµSharedStylesHost} from './dom/shared_styles_host';
export {DomSanitizerImpl as ÉµDomSanitizerImpl} from './security/dom_sanitization_service';
